<nav class="navbar fixed-top navbar-light bg-light header-logo-only">
  <a class="navbar-brand" *ngIf="!disabledLink" href="https://www.takeabreath.world/" >
    <img src="../../../../assets/images/logos/takeabreath_logo_new_font.svg">
  </a>
  <a class="navbar-brand" *ngIf="disabledLink">
    <img src="../../../../assets/images/logos/takeabreath_logo_new_font.svg">
  </a>
</nav>
